module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.modal && _vm.active) ? _c('mai-modal', {
    attrs: {
      "title": _vm.active.name
    },
    on: {
      "close": function($event) {
        _vm.modal = false
      }
    }
  }, [(_vm.active) ? _c('params', {
    ref: "docParams",
    attrs: {
      "slot": "content",
      "parentId": _vm.active.id,
      "filename": _vm.active.filename,
      "crud": false
    },
    slot: "content"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": function($event) {
        return _vm.$refs.docParams.go()
      }
    }
  }, [_vm._v("\n        Generate\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": function($event) {
        _vm.modal = false
      }
    }
  }, [_vm._v("\n        Close\n      ")])])], 1) : _vm._e(), _vm._v(" "), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('vuetable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "show-edit": _vm.allowEditAndDelete,
      "show-delete": _vm.allowEditAndDelete,
      "has-slot": true,
      "table-data": _vm.tableData,
      "table-title": 'Reports',
      "fields": [{
        header: 'Name',
        prop: 'name',
        hideByDefault: false
      }, {
        header: 'Code',
        prop: 'code',
        hideByDefault: false
      }],
      "max-items": _vm.maxValue
    },
    on: {
      "table-delete-request": _vm.deleteEntity,
      "table-edit-request": _vm.handleEdit,
      "pages-remaining": _vm.loadMore
    },
    scopedSlots: _vm._u([{
      key: "icons",
      fn: function(maiScope) {
        return _c('div', {
          staticClass: "btn btn-primary",
          attrs: {
            "data-toggle": "tooltip",
            "title": "Download"
          },
          on: {
            "click": function($event) {
              return _vm.popup(maiScope.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-155fdfe3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Report/ReportSearchResults.vue
// module id = 2099
// module chunks = 1